const BLOCKED_STORE_ALLOWED_ROUTES = [
  'not-available',
  'about',
  'salesperson-not-available',
  'salesperson-about',
]

export default defineNuxtRouteMiddleware((to, from) => {
  const globalStore = useGlobalStore()

  if (
    !BLOCKED_STORE_ALLOWED_ROUTES.includes((to.name || '').toString()) &&
    !globalStore.storeIsAvailable
  ) {
    return navigateTo('/not-available')
  }

  // If the salesperson handle exists, we redirect to the same route with the handle
  if (from.params.salesperson && !to.params.salesperson) {
    if (Object.keys(to.query).length) {
      const searchParams = new URLSearchParams(to.query as Record<string, string>)
      return navigateTo(`/s/${from.params.salesperson}${to.path}?${searchParams.toString()}`)
    }

    return navigateTo(`/s/${from.params.salesperson}${to.path}`)
  }
})
